import { ReactNode } from 'react';
import { NavigationMenu } from './Navigation/NavigationMenu';
import { BrgHeader } from './Header/BrgHeader';
import { useSessionTimeout } from '../hooks/useSessionTimeout';
import './Navigation/Navigation.css';

interface LayoutProps {
  children: ReactNode;
}

export function Layout({ children }: LayoutProps) {
  useSessionTimeout();

  return (
    <div className="layout-container">
      {/* BRG Header */}
      <BrgHeader />

      {/* Navigation Header */}
      <div className="layout-header-wrapper">
        <NavigationMenu />
      </div>

      {/* Page Content */}
      <main className="layout-main" role="main">
        {children}
      </main>
    </div>
  );
}
